<template>
	<!-- NOTIFICATIONS -->
	<div>
		<vs-dropdown vs-custom-content :vs-trigger-click="false" class="cursor-pointer">
			<transition name="bounce">
				<p>
					<feather-icon
						icon="BellIcon"
						class="cursor-pointer mt-1 sm:mr-6 mr-2 text-white bold"
						:badge="totalUnreadNotifications"
						:svgClasses="[show ? `text-orange` : `text-warning`, 'stroke-current mr-1 h-6 w-6']"
					/>
				</p>
			</transition>
			<vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">
				<div class="notification-top text-center p-5 bg-success text-white">
					<h3 class="text-white g-subtitle">{{ totalUnreadNotifications }} {{ $t("Notification.New") }}</h3>
					<p class="opacity-80">{{ $t("Notification.AppNotifications") }}</p>
				</div>

				<component
					:is="scrollbarTag"
					ref="mainSidebarPs"
					class="scroll-area--nofications-dropdown p-0 mb-10"
					:settings="settings"
					:key="$vs.rtl"
				>
					<div
						class="
							rounded-b-lg
							text-primary
							w-full
							p-2
							text-right
							border border-b-1 border-l-0 border-r-0 border-solid
							d-theme-border-grey-light
						"
					>
						<span v-if="totalUnreadNotifications > 0" @click="confirmDeleteAllNotification">
							<feather-icon
								:title="$t('Notification.DeleteAllNotifications')"
								icon="TrashIcon"
								class="cursor-pointer mt-1 sm:mr-6 mr-2 cursor-pointer hover:text-danger"
								:svgClasses="[show ? `text-prymary` : `text-warning`, 'stroke-current mr-1 h-6 w-6']"
						/></span>

						<span>
							<feather-icon
								:title="$t('CreatePasswordVP.GoTo') + ' ' + $t('Preferences.Preferences')"
								icon="SettingsIcon"
								class="cursor-pointer mt-1 sm:mr-6 mr-2 cursor-pointer hover:text-success"
								@click="$router.push({name: 'dashboard-preferences', params: {id: 'notifications'}})"
								:svgClasses="[show ? `text-prymary` : `text-warning`, 'stroke-current mr-1 h-6 w-6']"
						/></span>
					</div>

					<ul class="bordered-items">
						<li
							v-for="ntf in unreadNotifications"
							:key="ntf.key"
							class="flex justify-between px-4 py-4 notification cursor-pointer"
						>
							<div class="flex items-start" @click="readNotification(ntf)">
								<feather-icon
									title="Revisar"
									:icon="notificationIcon(ntf.event)"
									:svgClasses="[
										`text-${category(ntf.event)}`,
										'stroke-current mr-1 h-6 w-6 hover:text-primary',
									]"
								></feather-icon>
								<div class="mx-2">
									<span
										class="font-medium block notification-title g-table--title"
										:class="[`text-${category(ntf.event)}`]"
										>{{ notificationTitle(ntf) }}</span
									>
									<small class="g-label--normal">{{
										notificationText(ntf).toLocaleLowerCase() | title
									}}</small>
									<vs-progress
										v-if="showProgress(ntf.event)"
										:indeterminate="indeterminateProgress(ntf.event)"
										:percent="currentProgress(ntf.event)"
										class="block mt-1 shadow-md w-full"
										color="success"
									></vs-progress>
									<p v-if="showLoaded(ntf.event)">
										<feather-icon
											icon="UploadCloudIcon"
											:svgClasses="[`text-success`, 'stroke-current mr-1 h-6 w-6']"
										></feather-icon>
									</p>
								</div>
							</div>

							<small class="mt-1 whitespace-no-wrap g-label--normal" @click="readNotification(ntf, true)"
								>{{ elapsedTime(ntf.added_on) }} <br />
								<span v-if="shoView(ntf)" class="text-primary underline ml-4" style="cursor: pointer"
									>{{ $t("View") }}
								</span></small
							>
						</li>
					</ul>
				</component>
			</vs-dropdown-menu>
		</vs-dropdown>

		<panic-notification
			@cancelEmit="cancelAlert"
			@acceptEmit="acceptAlert"
			:active="mountedPanicAlert"
			:notification="panicNotification"
			:url="url"
			:lat="lat"
			:lng="lng"
			v-if="mountedPanicAlert"
		/>
	</div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import firebase from "firebase/app";
import User from "@/models/User.js";
import Notification from "@/models/Notification.js";
import DateUtils from "@/helpers/DateUtils.js";
import moment from "moment";
import PanicNotification from "./PanicNotification.vue";

export default {
	components: {
		VuePerfectScrollbar,
		PanicNotification,
	},
	data() {
		return {
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			notifications: [],
			database: firebase.database(),
			userSession: new User(),
			show: true,
			notificationsDays: 1,
			notificationsNumber: 1,
			removeOldNotifications: false,
			totalUnreadNotifications: 0,
			EVENT_NOT_ASSIGNED: "EVENT_NOT_ASSIGNED",
			PANIC_ALARM: "PANIC_ALARM",
			activePanicEventLoop: false,
			url: "",
			lat: "",
			lng: "",
			mountedPanicAlert: false,
			panicNotification: null,
		};
	},
	computed: {
		notify_alert_configjson() {
			return this.$store.getters.getConfigjsonRequiredNotifyStatus();
		},
		notify_alert_type() {
			return this.$store.getters.getConfigjsonRequiredName();
		},
		notificationTitle() {
			return (notification) => {
				let text = "";
				switch (notification.event) {
					case "EVENT_ASSIGNED":
						text = this.$t("Notification.NEW_EVENT");
						break;
					case "EVENT_RESCHEDULED":
						text = this.$t("Notification.RESCHEDULED_EVENT");
						break;
					case this.EVENT_NOT_ASSIGNED:
						text = this.$t("Notification.EVENT_NOT_ASSIGNED");
						break;
					case "EVENT_IN_PROGRESS":
						text = this.$t("Notification.EVENT_IN_PROCESS");
						break;
					case "EVENT_FINALIZED":
						text = this.$t("Notification.EVENT_ENDED");
						break;
					case "EVENT_CANCELLED":
						text = this.$t("Notification.EVENT_CANCELLED");
						break;
					case "EVENT_ON_THE_WAY":
						text = this.$t("Notification.EVENT_ON_THE_WAY");
						break;
					case "EVENT_DELAYED":
						text = this.$t("Notification.EVENT_DELAYED");
						break;
					case "UPLOAD_FINALIZED":
						text = this.$t("Notification.FINALIZED");
						break;
					case "UPLOAD_LOADED":
						text = this.$t("Notification.LOADED");
						break;
					case "LOADED":
						text = this.$t("Notification.LOADED");
						break;
					case "UPLOAD_PROCESS":
						text = this.$t("Notification.PROCESS");
						break;
					case "DOWNLOAD_PROCESS":
						text = this.$t("Notification.PROCESS");
						break;
					case "DOWNLOAD_FINALIZED":
						text = this.$t("Notification.DOWNLOAD_FINALIZED").toUpperCase();
						break;
					case "PROCESS":
						text = this.$t("Reports.Reports").toUpperCase();
						break;
					case "FINALIZED":
						if (notification.title === "Finished upload") {
							text = this.$t("Notification.FINALIZED");
						} else {
							text = this.$t("Reports.ReportGeneratedText");
						}
						break;
					default:
						text = notification.title.toUpperCase();

						break;
				}
				return text;
			};
		},
		notificationText() {
			return (notification) => {
				let text = "";
				switch (notification.event) {
					case "NEW_EVENT":
					case "EVENT_ASSIGNED":
					case this.EVENT_NOT_ASSIGNED:
					case "EVENT_RESCHEDULED":
					case "EVENT_IN_PROGRESS":
					case "EVENT_FINALIZED":
					case "EVENT_ON_THE_WAY":
					case "EVENT_DELAYED":
						text = this.$t("Notification.EVENT");
						break;
					case "UPLOAD_FINALIZED":
					case "LOADED":
					case "UPLOAD_LOADED":
					case "UPLOAD_PROCESS":
						text = this.$t("Notification.UPLOAD_FILE");
						break;
					case "DOWNLOAD_PROCESS":
						text = this.$t("Notification.DOWNLOAD_FILE");
						break;
					case "DOWNLOAD_FINALIZED":
						text = this.$t("Notification.FINALIZED");
						break;
					case "PROCESS":
						text = this.$t("Reports.ProcessingReport");
						break;
					case "FINALIZED":
						if (notification.title === "Finished upload") {
							text = this.$t("Notification.LOADED");
						} else {
							text = this.$t("Reports.ReportGeneratedText");
						}
						break;
					default:
						text = notification.event;
						break;
				}
				return text;
			};
		},
		notificationIcon() {
			return (typeEvent) => {
				let iconName = "";
				switch (typeEvent) {
					case "EVENT_ASSIGNED":
						iconName = "CalendarIcon";
						break;
					case "EVENT_RESCHEDULED":
						iconName = "CalendarIcon";
						break;
					case this.EVENT_NOT_ASSIGNED:
						iconName = "ShoppingBagIcon";
						break;
					case "EVENT_IN_PROGRESS":
						iconName = "CalendarIcon";
						break;
					case "EVENT_FINALIZED":
						iconName = "CalendarIcon";
						break;
					case "EVENT_CANCELLED":
						iconName = "FrownIcon";
						break;
					case "EVENT_ON_THE_WAY":
						iconName = "TruckIcon";
						break;
					case "EVENT_DELAYED":
						iconName = "ClockIcon";
						break;
					case "UPLOAD_FINALIZED":
						iconName = "PackageIcon";
						break;
					case "UPLOAD_LOADED":
					case "LOADED":
						iconName = "FilePlusIcon";
						break;
					case "UPLOAD_PROCESS":
						iconName = "CpuIcon";
						break;
					case "DOWNLOAD_PROCESS":
						iconName = "CpuIcon";
						break;
					case "DOWNLOAD_FINALIZED":
						iconName = "DownloadCloudIcon";
						break;
					case "PROCESS":
						iconName = "FilePlusIcon";
						break;
					case "FINALIZED":
						iconName = "FileTextIcon";
						break;
					default:
						iconName = "MessageSquareIcon";
						break;
				}
				return iconName;
			};
		},
		category() {
			return (typeEvent) => {
				switch (typeEvent) {
					case "NEW_EVENT":
						return "success";
					case "EVENT_ASSIGNED":
						return "success";
					case this.EVENT_NOT_ASSIGNED:
						return "secondary";
					case "EVENT_RESCHEDULED":
						return "info";
					case "EVENT_IN_PROGRESS":
						return "warning";
					case "EVENT_FINALIZED":
						return "success";
					case "EVENT_CANCELLED":
						return "danger";
					case "EVENT_ON_THE_WAY":
						return "warning";
					case "EVENT_DELAYED":
						return "danger";
					case "UPLOAD_FINALIZED":
						return "primary";
					case "UPLOAD_LOADED":
					case "LOADED":
						return "success";
					case "UPLOAD_PROCESS":
						return "danger";
					default:
						return "secondary";
				}
			};
		},
		showProgress() {
			return (typeEvent) => {
				switch (typeEvent) {
					case "UPLOAD_FINALIZED":
					case "DOWNLOAD_FINALIZED":
						return true;
					case "UPLOAD_PROCESS":
					case "DOWNLOAD_PROCESS":
					case "PROCESS":
						return true;
					default:
						return false;
				}
			};
		},
		indeterminateProgress() {
			return (typeEvent) => {
				switch (typeEvent) {
					case "UPLOAD_PROCESS":
					case "DOWNLOAD_PROCESS":
					case "PROCESS":
						return true;
					default:
						return false;
				}
			};
		},
		showLoaded() {
			return (typeEvent) => {
				switch (typeEvent) {
					case "UPLOAD_LOADED":
					case "LOADED":
						return true;
					default:
						return false;
				}
			};
		},
		currentProgress() {
			return (typeEvent) => {
				switch (typeEvent) {
					case "UPLOAD_FINALIZED":
					case "DOWNLOAD_FINALIZED":
					case "FINALIZED":
						return 100;
					case "UPLOAD_LOADED":
						return 50;
					default:
						return 0;
				}
			};
		},
		shoView() {
			return (notification) => {
				switch (notification.event) {
					case "NEW_EVENT":
					case "EVENT_RESCHEDULED":
					case "EVENT_IN_PROGRESS":
					case "EVENT_FINALIZED":
						return true;
					case "FINALIZED":
						if (notification.title === "Finished upload") {
							return false;
						} else {
							return true;
						}
					default:
						return false;
				}
			};
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
		unreadNotifications() {
			return this.notifications.sort(this.compare);
		},
		readAvalibleEventsNotificationTrigger() {
			return this.$store.getters.getReadAvalibleEventsNotificationTrigger;
		},
		requiredPermissions() {
			return this.$store.getters.getRequiredPermissionsTrigger;
		},
		requiredPermissionsData() {
			return this.$store.getters.getRequiredPermissionsData;
		},
		deleteNotificationTrigger() {
			return this.$store.getters.getDeleteNotificationTrigger;
		},
		reloadNotificationTrigger() {
			return this.$store.getters.getReloadNotificationTrigger;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		elapsedTime(startTime) {
			const x = new Date(startTime);
			const now = new Date();
			let timeDiff = now - x;
			timeDiff /= 1000;

			moment().diff(x, "days");

			const seconds = Math.round(timeDiff);
			timeDiff = Math.floor(timeDiff / 60);

			const minutes = Math.round(timeDiff % 60);
			timeDiff = Math.floor(timeDiff / 60);

			const hours = Math.round(timeDiff % 24);
			timeDiff = Math.floor(timeDiff / 24);

			const days = Math.round(timeDiff % 365);
			timeDiff = Math.floor(timeDiff / 365);

			const years = timeDiff;

			if (years > 0) {
				return `${years + (years > 1 ? " Years " : " Year ")}ago`;
			} else if (days > 0) {
				return `${days + (days > 1 ? " Days " : " Day ")}ago`;
			} else if (hours > 0) {
				return `${hours + (hours > 1 ? " Hrs " : " Hour ")}ago`;
			} else if (minutes > 0) {
				return `${minutes + (minutes > 1 ? " Mins " : " Min ")}ago`;
			} else if (seconds > 0) {
				return seconds + (seconds > 1 ? " sec ago" : "just now");
			}

			return "Just Now";
		},
		// Method for creating dummy notification time
		randomDate({hr, min, sec}) {
			const date = new Date();
			if (hr) date.setHours(date.getHours() - hr);
			if (min) date.setMinutes(date.getMinutes() - min);
			if (sec) date.setSeconds(date.getSeconds() - sec);
			return date;
		},
		/**
		 * TODO: Adiciona o resta dias a una fecha espeficada
		 * @Param {String} stringDate fecha en formato string de la cual se va a restar o sumar
		 * @Param {Number} dayNums Entero positivo o negativo
		 */
		addOrLessDaysToDate(stringDate, dayNums) {
			const date = new Date(stringDate);
			return date.setDate(date.getDate() + dayNums);
		},
		/**
		 * TODO: Obtener todas las notificaciones desde firebase y suscribirse a los eventos
		 */
		async getNotifications() {
			// Obtenemos la preferencias guardadas en el indexedDB del navegador
			const preferences = await this.$store.dispatch("modulePreferences/getPreferences");
			if (preferences) {
				this.notificationsDays = preferences.notifications_days;
				this.notificationsNumber = preferences.notifications_number;
				this.removeOldNotifications = preferences.remove_old_notifications;

				if (this.removeOldNotifications) this.getOldNotifications();
			}

			// Obtener la fecha actual y le restamos el numero de dias para ver notificaciones
			// la completamos con el tiempo en 00 00 00 para filtrar en firebase

			const date = this.addOrLessDaysToDate(new Date(), this.notificationsDays * -1);
			const currentDate = DateUtils.toDefaultDateTime(new Date(date), "YYYY-MM-DD");
			const startAt = currentDate.split("-").join("") + "000000";

			const user = await this.userSession.getUser();
			const starCountRef = this.database
				.ref(`notification/${user.company_id}/web/`)
				.orderByChild("date")
				.startAt(+startAt)
				.limitToLast(+this.notificationsNumber);

			starCountRef.once("value", (snapshot) => {
				this.notifications = [];

				snapshot.forEach((childSnapshot) => {
					// key will be "ada" the first time and "alan" the second time
					let key = childSnapshot.key;

					const notification = new Notification({
						...childSnapshot.val(),
						key: key,
					});
					const exist = this.notifications.some((n) => n.key === key);
					if (!exist && notification.status === "unread") {
						this.notifications.push(notification);
					}
				});
				this.totalUnreadNotifications = this.notifications.length;
			});

			starCountRef.on("child_added", (data) => {
				if (data.val().event === "PROCESS") {
					const userInfo = JSON.parse(localStorage.userInfo);
					if (data.val().body.resource_id !== userInfo.datarutas_id) {
						return;
					}
				}

				this.addNotification(data.key, data.val());

				if (data.val().event === this.PANIC_ALARM) {
					const {cy, cx} = data.val().body;
					this.lat = cy;
					this.lng = cx;
					if (data.val().status === "unread") {
						this.setDataAlert();
					}
				}

				this.show = false;
				setTimeout(() => {
					this.show = true;
				}, 100);
			});

			starCountRef.on("child_changed", (data) => {
				const notification = new Notification({
					...data.val(),
					key: data.key,
				});

				this.setNotificationValues(data.key, data.val());
				this.show = false;
				setTimeout(() => {
					this.show = true;
				}, 100);

				if (this.$route.name === "apps-on-demand" && notification.event === "EVENT_ASSIGNED") {
					this.$store.commit("setAceptedEvents", notification);
				}

				if (data.val().event === "FINALIZED") {
					const userInfo = JSON.parse(localStorage.userInfo);
					if (data.val().body.resource_id === userInfo.datarutas_id) {
						this.$vs.notify({
							color: "success",
							title: this.$t("Notification.FINALIZED"),
							text: `${this.$t("Reports.ReportGeneratedText")}. ${this.$t(
								"Reports.ReportProcessFinish"
							)}`,
							fixed: true,
							position: "top-right",
						});
					}
				}
				this.totalUnreadNotifications = this.notifications.length;
			});

			starCountRef.on("child_removed", (data) => {
				this.deleteNotification(data.key);
			});
		},
		/**
		 * TODO: Obtener y eliminar notificaciones previas al numero de dias espesificado en preferencias
		 */
		async getOldNotifications() {
			// Obtener la fecha actual y la completamos con el yiempo en 00 00 00
			const date = this.addOrLessDaysToDate(new Date(), this.notificationsDays * -1);
			const currentDate = DateUtils.toDefaultDateTime(new Date(date), "YYYY-MM-DD");
			const startAt = currentDate.split("-").join("") + "000000";

			const user = await this.userSession.getUser();
			const starCountRef = this.database
				.ref(`notification/${user.company_id}/web/`)
				.orderByChild("date")
				.endAt(+startAt)
				.limitToLast(+this.notificationsNumber);
			const oldNotifications = [];
			starCountRef.once("value", (snapshot) => {
				snapshot.forEach((childSnapshot) => {
					// key will be "ada" the first time and "alan" the second time
					let key = childSnapshot.key;
					const notification = new Notification({
						...childSnapshot.val(),
						key: key,
					});
					oldNotifications.push(notification);
				});
				this.deleteOldNotification(oldNotifications);
			});
		},
		async readNotification(notification, go = false) {
			const user = await this.userSession.getUser();
			try {
				// Create a root reference
				const {key, ...restData} = notification;
				const notificationUp = new Notification(restData);
				notificationUp.status = "read";
				const starCountRef = this.database;
				starCountRef.ref(`notification/${user.company_id}/web/${key}`).set(notificationUp);
				if (go) this.goTo(notification);
			} catch (error) {
				throw new Error(error);
			}
		},
		async readAvalibleEventsNotification() {
			const user = await this.userSession.getUser();
			try {
				// Create a root reference
				const starCountRef = this.database;
				this.notifications.forEach((notification) => {
					const key = notification.key;
					const notificationUp = new Notification(notification);
					notificationUp.status = "read";
					delete notificationUp.key;
					starCountRef.ref(`notification/${user.company_id}/web/${key}`).set(notificationUp);
				});
			} catch (error) {
				throw new Error(error);
			}
		},
		async readAllNotification() {
			const user = await this.userSession.getUser();
			try {
				const starCountRef = this.database;
				starCountRef.ref(`notification/${user.company_id}/web/`).set(null);
			} catch (error) {
				throw new Error(error);
			}
		},
		async deleteAllNotification() {
			try {
				const user = await this.userSession.getUser();
				Array.from(this.notifications).forEach((notification) => {
					const starCountRef = this.database;
					starCountRef.ref(`notification/${user.company_id}/web/`).child(notification.key).set(null);
				});
			} catch (error) {
				throw new Error(error);
			}
		},
		async deleteOldNotification(oldNotifications) {
			try {
				const user = await this.userSession.getUser();
				Array.from(oldNotifications).forEach((notification) => {
					const starCountRef = this.database;
					starCountRef.ref(`notification/${user.company_id}/web/`).child(notification.key).set(null);
				});
			} catch (error) {
				throw new Error(error);
			}
		},
		addNotification(key, data) {
			const d = {...data, key};
			const notification = new Notification(d);
			const exist = this.notifications.some((n) => n.key === key);
			if (!exist && notification.status === "unread") {
				this.notifications.unshift(notification);
			}

			if (notification.event === this.EVENT_NOT_ASSIGNED) {
				this.$store.commit("setAvailableEvents");
			}

			if (notification.event === this.PANIC_ALARM) {
				this.panicNotification = new Notification(notification);
			}

			if (this.$route.name === "apps-on-demand" && notification.event === "EVENT_ASSIGNED") {
				this.$store.commit("setAceptedEvents", notification);
			}
			this.totalUnreadNotifications = this.notifications.length;
		},
		deleteNotification(key) {
			const ItemIndex = this.notifications.findIndex((p) => p.key === key);
			this.notifications.splice(ItemIndex, 1);
			this.totalUnreadNotifications = this.notifications.length;
		},
		setNotificationValues(key, data) {
			const notificationIndex = this.notifications.findIndex((p) => p.key === key);
			if (notificationIndex >= 0) Object.assign(this.notifications[notificationIndex], data);
		},
		goTo({event, body}) {
			switch (event) {
				case "NEW_EVENT":
				case "EVENT_RESCHEDULED":
				case "EVENT_IN_PROCESS":
				case "EVENT_FINALIZED":
					this.$router.push({
						name: "resource-calendar",
						params: {id: body.resource_id},
					});
					break;
				case "FINALIZED":
					this.$router.push({name: `apps-reports-list-id`, params: {id: body.job_id}}).catch(() => {});
					break;
				case "UPLOAD_FINALIZED":
					return "primary";
					break;
				case "UPLOAD_LOADED":
				case "LOADED":
					return "success";
					break;
				case "UPLOAD_PROCESS":
					return "danger";
					break;
				default:
					return "secondary";
			}
		},
		/** comparar mayor por el atributo date */
		compare(a, b) {
			if (Date.parse(a.added_on) > Date.parse(b.added_on)) {
				return -1;
			}
			if (Date.parse(a.added_on) < Date.parse(b.added_on)) {
				return 1;
			}
			return 0;
		},
		showErrorAlert() {
			const name = this.notify_alert_type;
			this.$vs.notify({
				color: "warning",
				title: this.$t("NewTypeConfigRequired"),
				text: this.$t("Roles.Permissions.JsonConfigNotFoundTex"),
				icon: "info",
				time: 6000,
			});
		},
		async getIdResourcesOnMessages() {
			const user = await this.userSession.getUser();
			const starMessagesCompanyRef = this.database.ref(`messages/${user.company_id}`);

			starMessagesCompanyRef.on("value", (snapshot) => {
				this.resourcesId = [];
				snapshot.forEach((childSnapshot) => {
					// key will be the resource id on the firt content
					let key = childSnapshot.key;
					// childData will be the actual contents of the child
					this.resourcesId.push(key);
				});

				this.filterMessages();
				this.unseenTotalMessages();
			});

			starMessagesCompanyRef.on("child_changed", (snapshot) => {
				let unseenMessages = 0;
				snapshot.forEach((childSnapshot) => {
					let childData = {...childSnapshot.val()};
					this.usernameSet.add(childData.user_name);
					if (childData.seen === false) {
						unseenMessages += 1;
					}
				});
				const childChanged = +snapshot.key;
				// verificamos si el elemento que cambio este en la lista de los actuales
				const recentCommunicationResources = this.$store.state.moduleResource.resourcesComunication;
				const someResource = recentCommunicationResources.some((resource) => resource.id === childChanged);

				// Si el recurso no se encuntra disparamos el trigger para actualizar la lista
				if (!someResource && unseenMessages > 0) {
					this.$store.commit("setUsernameResources", Array.from(this.usernameSet));
					this.$store.commit("setCommunicationMesaagesReload");

					// Capturamos el username del ultimo recurso agregado
					const lastUsernameAdded = [...this.usernameSet].pop();
					this.$vs.notify({
						color: "success",
						title: this.$t("Communication.Communication"),
						text: `${this.$t("Communication.NewMessage")} ${this.$t(
							"Resource.Resource"
						)} ${lastUsernameAdded.toUpperCase()}`,
						icon: "message",
						time: 7000,
						position: "top-right",
						//fixed:true,
					});
				}
			});
		},
		async filterMessages() {
			const user = await this.userSession.getUser();
			//this.messages = [];
			this.usernameSet = new Set();
			for (let index = 0; index < this.resourcesId.length; index++) {
				const element = this.resourcesId[index];
				const starMessagesCompanyRef = this.database
					.ref(`messages/${user.company_id}/${element}`)
					.orderByChild("state")
					.equalTo("Pendiente por resolver");

				starMessagesCompanyRef.once("value", (snapshot) => {
					snapshot.forEach((childSnapshot) => {
						// key will be "ada" the first time and "alan" the second time
						let key = childSnapshot.key;
						// childData will be the actual contents of the child
						let childData = {
							...childSnapshot.val(),
							key: key,
						};
						//this.messages.push(childData);
						this.usernameSet.add(childData.user_name);
					});
				});
			}

			//this.$store.commit("setUnreadMessages", this.messages.flat());
			this.$store.commit("setUsernameResources", Array.from(this.usernameSet));
		},
		async unseenTotalMessages() {
			const user = await this.userSession.getUser();
			this.messages = [];

			for (let index = 0; index < this.resourcesId.length; index++) {
				const element = this.resourcesId[index];
				const starMessagesCompanyRef = this.database
					.ref(`messages/${user.company_id}/${element}`)
					.orderByChild("seen")
					.equalTo(false);

				starMessagesCompanyRef.once("value", (snapshot) => {
					snapshot.forEach((childSnapshot) => {
						// key will be "ada" the first time and "alan" the second time
						let key = childSnapshot.key;
						// childData will be the actual contents of the child
						let childData = {
							...childSnapshot.val(),
							key: key,
						};
						this.messages.push(childData);
						//this.usernameSet.add(childData.user_name);
					});
				});
			}

			this.$store.commit("setUnreadMessages", this.messages.flat());
			//this.$store.commit("setUsernameResources", Array.from(this.usernameSet));
		},
		confirmDeleteAllNotification() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Notification.DeleteAllNotifications"),
				accept: this.deleteAllNotification,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		setDataAlert() {
			let width = 400;
			let height = 400;
			let zoom = 19;
			let key = process.env.VUE_APP_HERE_MAP_API_KEY;

			this.url = `https://image.maps.ls.hereapi.com/mia/1.6/mapview
			?apiKey=${key}
			&c=${this.lat},${this.lng}
			&z=${zoom}
			&w=${width}
			&h=${height}			
			&poix=${this.lat},${this.lng}`;
			this.mountedPanicAlert = true;
			//createStaticMapImage();
		},
		acceptAlert() {
			this.mountedPanicAlert = false;
			this.readNotification(this.panicNotification);
			const currentModuleName = this.$store.state.currentModule.name;
			if (currentModuleName !== "dashboard-maps") {
				this.$router.push({
					name: "dashboard-maps",
					params: {notification: this.panicNotification},
				});
			} else {
				this.$store.dispatch("moduleMap/locatePanicAlarm", this.panicNotification);
			}
		},
		cancelAlert() {
			this.activePanicEventLoop = false;
			this.mountedPanicAlert = false;
		},
	},
	watch: {
		notify_alert_configjson(val) {
			this.showErrorAlert();
		},
		readAvalibleEventsNotificationTrigger(val) {
			this.readAvalibleEventsNotification();
		},
		requiredPermissions(val) {
			this.$vs.notify({
				color: "danger",
				title: this.$t("Permissions.RequiredPermissions"),
				text: `${this.$t("Roles.Permissions.NotPermissionsText")} ${this.requiredPermissionsData.error}`,
				time: 7000,
				icon: "lock",
			});
		},
		deleteNotificationTrigger() {
			this.deleteAllNotification();
		},
		reloadNotificationTrigger() {
			this.notifications = [];
			this.totalUnreadNotifications = 0;
			setTimeout(() => {
				this.getNotifications();
			}, 200);
		},
	},
	filters: {
		format(str) {
			return str ? str.replace(/_/g, " ") : "";
		},
	},
	created() {
		// get messages for module comunication
		this.getIdResourcesOnMessages();
	},
	mounted() {
		this.getNotifications();
	},
};
</script>

<style lang="scss" scoped>
.feather-icon-badge {
	background: #323232 !important;
}

.bounce-enter-active {
	animation: bounce-in 0.7s;
	color: #ff9f43;
}

.bounce-leave-active {
	animation: bounce-in 0.5s reverse;
	color: #ff9f43;
}

@keyframes bounce-in {
	0% {
		transform: scale(0);
	}
	50% {
		transform: scale(1.5);
	}
	100% {
		transform: scale(1);
	}
}
</style>
